var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14258 3.07812C0.806641 2.6862 0.666667 2.26628 0.722656 1.81836C0.778646 1.37044 0.974609 0.978516 1.31055 0.642578C1.64648 0.306641 2.06641 0.138672 2.57031 0.138672H27.4297C27.9336 0.138672 28.3535 0.306641 28.6895 0.642578C29.0254 0.978516 29.2214 1.37044 29.2773 1.81836C29.3333 2.26628 29.1934 2.6862 28.8574 3.07812C28.1296 3.97396 27.3177 5.00977 26.4219 6.18555C25.526 7.36133 24.6022 8.53711 23.6504 9.71289C22.7546 10.8887 21.9147 11.9805 21.1309 12.9883C20.403 13.9961 19.7871 14.8079 19.2832 15.4238C18.8353 15.9837 18.6113 16.2637 18.6113 16.2637V27.0137C18.6113 27.5176 18.4154 27.9655 18.0234 28.3574C17.6875 28.6934 17.2676 28.8613 16.7637 28.8613H13.2363C12.7324 28.8613 12.2845 28.6934 11.8926 28.3574C11.5566 27.9655 11.3887 27.5176 11.3887 27.0137V16.2637C11.3887 16.2637 11.1367 15.9837 10.6328 15.4238C10.1849 14.8079 9.56901 13.9961 8.78516 12.9883C8.05729 11.9805 7.21745 10.8887 6.26562 9.71289C5.36979 8.53711 4.47396 7.36133 3.57812 6.18555C2.68229 5.00977 1.87044 3.97396 1.14258 3.07812Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2a5777112e2239714d7f88ac40ba2168.svg";
export { ForwardRef as ReactComponent };